 
    <style scoped>
        
        .app-container {
            width: 100%;
            max-width: 420px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            min-height: 100vh;
            position: relative;
        }
        .page-content {
            flex: 1;
            padding: 15px;
            overflow-y: auto;
            padding-bottom: 70px;
            filter: blur(0);
            transition: filter 0.3s ease;
        }
        .page-content.blurred {
            filter: blur(5px);
        }
        
        /* 流程导航 */
        .process-nav {
            background: white;
            border-radius: 16px;
            padding: 20px 15px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .process-tabs {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
            border-bottom: 1px solid #eee;
        }
        .process-tab {
            flex: 1;
            text-align: center;
            padding: 10px 0;
            cursor: pointer;
            position: relative;
            font-weight: 500;
            color: #999;
        }
        .process-tab.active {
            color: #3498db;
            font-weight: 600;
        }
        .process-tab.active:after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 10%;
            right: 10%;
            height: 3px;
            background: #3498db;
            border-radius: 3px;
        }
        
        /* 流程内容 */
        .process-content {
            min-height: 150px;
        }
        .process-section {
            display: none;
        }
        .process-section.active {
            display: block;
            animation: fadeIn 0.5s;
        }
        .process-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 15px;
            color: #3498db;
        }
        .process-desc {
            font-size: 14px;
            color: #666;
            margin-bottom: 15px;
            line-height: 1.6;
        }
        .process-action {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
        .btn {
            padding: 12px 20px;
            border-radius: 10px;
            border: none;
            font-size: 15px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .btn-primary {
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
            color: white;
        }
        .btn-primary:hover {
            opacity: 0.9;
            transform: translateY(-2px);
        }
        .btn-secondary {
            background: #f8f9fa;
            color: #3498db;
            border: 1px solid #3498db;
        }
        .btn-secondary:hover {
            background: #e8f4fc;
        }
        .link {
            color: #3498db;
            text-decoration: none;
            font-size: 14px;
            display: inline-flex;
            align-items: center;
            margin-top: 10px;
        }
        .link i {
            margin-right: 5px;
        }
        
        /* 样本状态 */
        .sample-status {
            background: white;
            border-radius: 16px;
            padding: 20px 15px;
            margin-bottom: 20px;
            box-shadow: 0 4px 15px rgba(0,0,0,0.05);
        }
        .status-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            padding-bottom: 15px;
            border-bottom: 1px solid #eee;
        }
        .status-title {
            font-size: 16px;
            font-weight: 600;
            color: #3498db;
        }
        .sample-info {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 20px;
        }
        .sample-item {
            display: flex;
            align-items: center;
        }
        .sample-label {
            width: 100px;
            color: #666;
            font-size: 14px;
        }
        .sample-value {
            flex: 1;
            font-size: 14px;
            font-weight: 500;
        }
        
        /* 时间轴 */
        .timeline {
            position: relative;
            padding-left: 30px;
        }
        .timeline:before {
            content: '';
            position: absolute;
            left: 10px;
            top: 0;
            bottom: 0;
            width: 2px;
            background: #e0e0e0;
        }
        .timeline-item {
            position: relative;
            margin-bottom: 20px;
        }
        .timeline-dot {
            position: absolute;
            left: -30px;
            top: 0;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #e0e0e0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .timeline-dot.active {
            background: #2ecc71;
        }
        .timeline-dot i {
            color: white;
            font-size: 12px;
        }
        .timeline-content {
            padding: 10px 15px;
            background: #f8f9fa;
            border-radius: 10px;
        }
        .timeline-title {
            font-size: 14px;
            font-weight: 500;
            margin-bottom: 5px;
        }
        .timeline-desc {
            font-size: 12px;
            color: #888;
        }
        .timeline-item.active .timeline-content {
            background: #e8f4fc;
            border-left: 3px solid #3498db;
        }
        
        /* 底部导航栏 */
        .tab-bar {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 60px;
            background: white;
            display: flex;
            justify-content: space-around;
            align-items: center;
            border-top: 1px solid #eee;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.05);
            z-index: 100;
            max-width: 420px;
            margin: 0 auto;
        }
        .tab-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            flex: 1;
            height: 100%;
            cursor: pointer;
            transition: all 0.3s;
            color: #999;
        }
        .tab-item.active {
            color: #3498db;
        }
        .tab-icon {
            font-size: 20px;
            margin-bottom: 4px;
        }
        .tab-name {
            font-size: 12px;
        }
        
        /* 模态框样式 */
        .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.6);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1000;
            padding: 20px;
            animation: fadeIn 0.3s;
        }
        .modal-container {
            background: white;
            border-radius: 16px;
            width: 100%;
            max-width: 350px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.2);
            animation: slideUp 0.4s;
        }
        .modal-header {
            padding: 20px;
            text-align: center;
            background: linear-gradient(135deg, #3498db 0%, #2ecc71 100%);
            color: white;
        }
        .modal-title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 5px;
        }
        .modal-subtitle {
            font-size: 14px;
            opacity: 0.9;
        }
        .modal-body {
            padding: 20px;
        }
        .service-options {
            display: flex;
            flex-direction: column;
            gap: 15px;
        }
        .service-option {
            display: flex;
            align-items: center;
            padding: 15px;
            border: 1px solid #e0e0e0;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .service-option:hover {
            border-color: #3498db;
            background: #f0f7ff;
            transform: translateY(-2px);
        }
        .service-icon {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: #f0f5ff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            font-size: 18px;
            color: #3498db;
        }
        .service-text {
            flex: 1;
            font-size: 16px;
            font-weight: 500;
        }
        .modal-footer {
            padding: 15px 20px;
            text-align: center;
            border-top: 1px solid #eee;
        }
        .close-btn {
            background: #f8f9fa;
            color: #666;
            border: 1px solid #ddd;
            border-radius: 20px;
            padding: 8px 20px;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .close-btn:hover {
            background: #e9ecef;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }
        
        @keyframes slideUp {
            from { 
                opacity: 0;
                transform: translateY(20px);
            }
            to { 
                opacity: 1;
                transform: translateY(0);
            }
        }
    </style>
 
    <template>
        <div class="app-container">
            <div class="page-content" :class="{ blurred: showModal }">
                <!-- 流程导航 -->
                <div class="process-nav">
                    <div class="process-tabs">
                        <div class="process-tab" :class="{ active: currentProcess === 'scan' }" @click="currentProcess = 'scan'">扫码绑定</div>
                        <div class="process-tab" :class="{ active: currentProcess === 'collect' }" @click="currentProcess = 'collect'">乳牙采集</div>
                        <div class="process-tab" :class="{ active: currentProcess === 'return' }" @click="currentProcess = 'return'">免费回寄</div>
                    </div>

                    <div class="process-content">
                        <!-- 扫码绑定 -->
                        <div class="process-section" :class="{ active: currentProcess === 'scan' }">
                            <div class="process-title">扫码绑定采集盒</div>
                            <div class="process-desc">请使用手机扫描乳牙采集盒上的二维码，完成绑定流程</div>
                            <div class="process-action">
                                <button class="btn btn-primary" @click="startScan">
                                    <i class="fas fa-camera"></i> 开始扫码绑定
                                </button>
                                <a href="javascript:void(0)" class="link" @click="viewManual">
                                    <i class="fas fa-file-pdf"></i> 查看说明书
                                </a>
                            </div>
                        </div>

                        <!-- 乳牙采集 -->
                        <div class="process-section" :class="{ active: currentProcess === 'collect' }">
                            <div class="process-title">乳牙样本采集</div>
                            <div class="process-desc" v-if="collectionStatus.collected">
                                您的乳牙样本已成功采集，状态：{{ collectionStatus.status }}
                            </div>
                            <div class="process-desc" v-else>
                                您尚未采集乳牙样本，请按照指引完成采集
                            </div>
                            <div class="process-action">
                                <button class="btn" :class="collectionStatus.collected ? 'btn-secondary' : 'btn-primary'" @click="handleCollection">
                                    <i class="fas" :class="collectionStatus.collected ? 'fa-eye' : 'fa-tooth'"></i> 
                                    {{ collectionStatus.collected ? '查看采集状态' : '去采集' }}
                                </button>
                            </div>
                        </div>

                        <!-- 免费回寄 -->
                        <div class="process-section" :class="{ active: currentProcess === 'return' }">
                            <div class="process-title">免费回寄服务</div>
                            <div class="process-desc">我们提供免费上门取件服务，请预约合适的时间，快递员将上门取件</div>
                            <div class="process-action">
                                <button class="btn btn-primary" @click="schedulePickup">
                                    <i class="fas fa-truck"></i> 去寄件
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 样本状态 -->
                <div class="sample-status">
                    <div class="status-header">
                        <div class="status-title">当前样本状态：细胞检测合格</div>
                    </div>

                    <div class="sample-info">
                        <div class="sample-item">
                            <div class="sample-label">姓名：</div>
                            <div class="sample-value">张三</div>
                        </div>
                        <div class="sample-item">
                            <div class="sample-label">乳牙采集盒：</div>
                            <div class="sample-value">BS0000111111</div>
                        </div>
                    </div>

                    <!-- 时间轴 -->
                    <div class="timeline">
                        <div class="timeline-item" :class="{ active: index < 5 }" v-for="(step, index) in timelineSteps" :key="index">
                            <div class="timeline-dot" :class="{ active: index < 5 }">
                                <i class="fas fa-check" v-if="index < 5"></i>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-title">{{ step.title }}</div>
                                <div class="timeline-desc">{{ step.desc }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
               <!-- 服务选择模态框 -->
        <div class="modal-overlay" v-if="showModal">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="modal-title">爱乐存服务</div>
                    <div class="modal-subtitle">请选择您需要的服务类型</div>
                </div>
                <div class="modal-body">
                    <div class="service-options">
                        <div class="service-option" @click="selectService('bind')">
                            <div class="service-icon">
                                <i class="fas fa-box"></i>
                            </div>
                            <div class="service-text">我要存储</div>
                        </div>
                        <div class="service-option" @click="selectService('card')">
                            <div class="service-icon">
                                <i class="fas fa-check-circle"></i>
                            </div>
                            <div class="service-text">我要核销</div>
                        </div>
                        <div class="service-option" @click="closeModal">
                            <div class="service-icon">
                                <i class="fas fa-check-square"></i>
                            </div>
                            <div class="service-text">我已存储</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="close-btn" @click="closeModal">关闭</button>
                </div>
            </div>
        </div>
        </div>
      
    </template>

    <script>
import router from '../router';

        export default{
            name: 'Home',
            data() {return  {
                currentTab: 'home',
                currentProcess: 'scan',
                collectionStatus: {
                    collected: false,
                    status: '已完成'
                },
                timelineSteps: [
                    { title: '样本采集', desc: '2023-10-15 14:30' },
                    { title: '抵达实验室', desc: '2023-10-18 09:15' },
                    { title: '牙髓提取成功', desc: '2023-10-20 11:40' },
                    { title: '细胞培养成功', desc: '2023-11-05 16:20' },
                    { title: '细胞检测合格', desc: '2023-11-15 10:30' },
                    { title: '正式入库冻存', desc: '预计2023-11-25' }
                ],
                showModal: true
            }},
            mounted() {
                // 页面加载时显示模态框
                this.showModal = true;
            },
            methods: {
                switchTab(tab) {
                    this.currentTab = tab;
                    if (tab !== 'home') {
                        alert(`切换到${tab === 'cell' ? '细胞' : '我的'}页面`);
                    }
                },
                startScan() {
                    alert('打开相机扫码功能');
                },
                viewManual() {
                    alert('打开说明书图片页面');
                },
                handleCollection() {
                    alert('跳转到乳牙样本采集页面');
                    this.collectionStatus.collected = true;
                },
                schedulePickup() {
                    alert('跳转到回寄采集盒页面');
                },
                selectService(service) {
                    
                    this.showModal = false;
                    router.push(service);
                },
                closeModal() {
                    this.showModal = false;
                }
            }
        };
    </script>
 